import { createSelector } from 'reselect'

const _getCurrentOrg = state => {
  return state.organizations.items.find(
    org => org.id === parseInt(state.organization.orgId)
  )
}

export const currentOrg = createSelector([_getCurrentOrg], org => {
  return org
})



// WEBPACK FOOTER //
// ./src/selectors/organization.js